import script from "./goodsQr.vue?vue&type=script&setup=true&lang=js"
export * from "./goodsQr.vue?vue&type=script&setup=true&lang=js"

import "./goodsQr.vue?vue&type=style&index=0&id=83845930&lang=scss&scoped=true"

import exportComponent from "F:\\webStorm workspace\\ujk_ad\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83845930"]])

export default __exports__